function formatDefaultDate(date) {
  const yearString = date.getUTCFullYear();
  const monthString = (`0${(date.getUTCMonth() + 1)}`).slice(-2);
  const dateString = (`0${date.getUTCDate()}`).slice(-2);
  const hourString = (`0${date.getUTCHours()}`).slice(-2);
  const minuteString = (`0${date.getUTCMinutes()}`).slice(-2);

  const formattedDate = `${yearString}-${monthString}-${dateString}T${hourString}:${minuteString}`;
  return formattedDate;
}

export default formatDefaultDate;
